export default __webpack_public_path__ + "static/media/J-Mpofu.1adbe08c.jpg";